import { jsx as o } from "react/jsx-runtime";
import { forwardRef as u } from "react";
import { d as c, T as p } from "./Tooltip-g6iElNQB.js";
import { P as s } from "./Pill-uAcQLotY.js";
const d = {
  Waalaxy: "purple",
  LinkedIn: "info",
  Internal: "accent",
  CSV: "warning",
  Manual: "neutral",
  Unknown: "error"
}, P = u(function({ source: l, variant: a = "soft", size: t = "sm", children: e, description: r, title: i, ...f }, m) {
  const n = /* @__PURE__ */ o(
    s,
    {
      ref: m,
      tone: d[l],
      variant: a,
      size: t,
      "data-source": l,
      title: r ?? i,
      ...f,
      children: e
    }
  );
  return r ? /* @__PURE__ */ o(c, { delayDuration: 200, children: /* @__PURE__ */ o(p, { label: r, children: n }) }) : n;
});
P.displayName = "SourcePill";
export {
  P as S
};
//# sourceMappingURL=SourcePill-CgQffD-I.js.map
